import { defineMessages } from 'react-intl';

export default defineMessages({
    dueDate: {
        id: 'ent.billing.invoices-table.Due Date',
        defaultMessage: 'Due Date',
    },
    billDate: {
        id: 'ent.billing.invoices-table.Bill Date',
        defaultMessage: 'Bill Date',
    },
    billStatus: {
        id: 'ent.billing.invoices-table.Status',
        defaultMessage: 'Status',
    },
    lastPaymentDate: {
        id: 'ent.billing.invoices-table.Last Payment Date',
        defaultMessage: 'Last Payment Date',
    },
    invoiceTotal: {
        id: 'ent.billing.invoices-table.Invoice Total',
        defaultMessage: 'Invoice Total',
    },
    paid: {
        id: 'ent.billing.invoices-table.Paid',
        defaultMessage: 'Paid',
    },
    pastDue: {
        id: 'ent.billing.invoices-table.Past Due',
        defaultMessage: 'Past Due',
    },
    outstanding: {
        id: 'ent.billing.invoices-table.Outstanding',
        defaultMessage: 'Outstanding',
    },
    invoice: {
        id: 'ent.billing.invoices-table.Invoice Number',
        defaultMessage: 'Invoice Number',
    },
    pay: {
        id: 'ent.billing.invoices-table.Pay',
        defaultMessage: 'Pay',
    },
    noMatchingPayments: {
        id: 'ent.billing.invoices-table.No matching payments.',
        defaultMessage: 'No matching payments.',
    },
});
